"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPicker = void 0;
var L = require("leaflet");
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
var LocationPicker = (function () {
    function LocationPicker(element) {
        this.locationMap = null;
        this.programmaticallySettingLocation = false;
        this.mapExpanded = false;
        this.readonlyState = true;
        this.element = element;
        this.containerElement = element.closest('.md-form').find('.form-location-container').first();
        this.OnCreate();
    }
    LocationPicker.prototype.OnCreate = function () {
        var _this = this;
        var _a;
        this.readonlyState = ((_a = this.element.closest('.md-form').find('input').attr('readonly')) !== null && _a !== void 0 ? _a : false);
        this.containerElement.css('width', this.containerElement.data('container-width'));
        this.containerElement.css('height', this.containerElement.data('container-height'));
        var showMap = this.element.closest('.md-form').find('.connxt-map-button');
        showMap.on('click', function () {
            _this.handleShowHideMap();
        });
        $(this.element).on('input', function () {
            var _a, _b, _c, _d;
            if (_this.programmaticallySettingLocation) {
                return;
            }
            if (!_this.element.valid()) {
                return;
            }
            var latLng = (_c = (_b = ((_a = $(_this.element).val()) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.split(",").map(Number);
            if (Array.isArray(latLng) && latLng.length == 2) {
                _this.programmaticallySettingLocation = true;
                (_d = _this.locationMap) === null || _d === void 0 ? void 0 : _d.updateLocation(latLng[0], latLng[1]);
                _this.programmaticallySettingLocation = false;
            }
        });
        this.element.closest('.md-form').find('[data-toggle="tooltip"]').tooltip();
        this.element.closest('.md-form').find('[data-toggle="tooltip"]').on('click', function () {
            $(this).tooltip('hide');
        });
    };
    LocationPicker.prototype.handleShowHideMap = function () {
        if (!this.mapExpanded) {
            this.showMap();
        }
        else {
            this.hideMap();
        }
        if (this.locationMap == null) {
            this.locationMap = new LocationMap(this.element, this.containerElement, this.readonlyState);
        }
        this.element.closest('.md-form').find('[data-toggle="tooltip"]').tooltip();
        this.locationMap.recenter();
    };
    LocationPicker.prototype.showMap = function () {
        var iconButton = this.element.closest('.md-form').find('.connxt-group-input-icon i');
        this.element.attr('placeholder', this.element.data('expanded-placeholder'));
        $(this.containerElement).removeClass('d-none');
        this.mapExpanded = true;
        iconButton.attr('data-original-title', iconButton.data('expanded-title'));
    };
    LocationPicker.prototype.hideMap = function () {
        var iconButton = this.element.closest('.md-form').find('.connxt-group-input-icon i');
        this.element.attr('placeholder', this.element.data('unexpanded-placeholder'));
        $(this.containerElement).addClass('d-none');
        this.mapExpanded = false;
        iconButton.attr('data-original-title', iconButton.data('unexpanded-title'));
    };
    return LocationPicker;
}());
exports.LocationPicker = LocationPicker;
var LocationMap = (function () {
    function LocationMap(inputElement, containerElement, _readonlyState) {
        this._map = null;
        this._currentMarker = null;
        this._latitude = null;
        this._longitude = null;
        this._defaultLatitude = null;
        this._defaultLongitude = null;
        this._readonlyState = _readonlyState;
        this._$containerElement = containerElement;
        this._$inputElement = inputElement;
        this.initMap();
    }
    LocationMap.prototype.invalidateSize = function () {
        var _a;
        (_a = this._map) === null || _a === void 0 ? void 0 : _a.invalidateSize();
    };
    LocationMap.prototype.updateLocation = function (lat, lng) {
        var _a, _b;
        if (!LocationMap.isNumber(lat) || !LocationMap.isNumber(lng)) {
            return;
        }
        this._latitude = parseFloat(lat);
        this._longitude = parseFloat(lng);
        var latLng = new L.LatLng(lat, lng);
        (_a = this._currentMarker) === null || _a === void 0 ? void 0 : _a.setLatLng(latLng);
        (_b = this._map) === null || _b === void 0 ? void 0 : _b.panTo(latLng);
        this._$inputElement.valid();
    };
    LocationMap.prototype.recenter = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var zoomLevel = this._latitude != null && this._longitude != null ? 17 : 0;
        var latLng = new L.LatLng((_b = (_a = this._currentMarker) === null || _a === void 0 ? void 0 : _a.getLatLng().lat) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._currentMarker) === null || _c === void 0 ? void 0 : _c.getLatLng().lng) !== null && _d !== void 0 ? _d : 0);
        setTimeout(function () {
            var _a, _b;
            (_a = _this._map) === null || _a === void 0 ? void 0 : _a.invalidateSize();
            (_b = _this._map) === null || _b === void 0 ? void 0 : _b.setView(latLng, zoomLevel);
        }, 0);
    };
    LocationMap.prototype.initMap = function (zoomLevel) {
        if (zoomLevel === void 0) { zoomLevel = 17; }
        var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        var osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
        var osm = new L.TileLayer(osmUrl, {
            minZoom: 2,
            maxZoom: 17,
            attribution: osmAttrib
        });
        var latitude = null;
        var longitude = null;
        var latLng = this._$inputElement.val();
        if (latLng != null && latLng !== '') {
            var splitted = latLng.trim().split(',');
            if (splitted.length === 2) {
                latitude = Number(splitted[0]);
                longitude = Number(splitted[1]);
            }
        }
        ;
        if (this._$containerElement.data('default-latitude') != null) {
            this._defaultLatitude = Number(this._$containerElement.data('default-latitude'));
        }
        if (this._$containerElement.data('default-longitude') != null) {
            this._defaultLongitude = Number(this._$containerElement.data('default-longitude'));
        }
        if (LocationMap.isNumber(latitude) && LocationMap.isNumber(longitude)) {
            this._latitude = parseFloat(latitude);
            this._longitude = parseFloat(longitude);
        }
        if (latitude == null || longitude == null) {
            this._latitude = this._defaultLatitude;
            this._longitude = this._defaultLongitude;
        }
        this.setLocation(this._map, this._$containerElement[0], zoomLevel, osm, this._latitude, this._longitude);
    };
    LocationMap.prototype.setLocation = function (map, element, zoomLevel, osm, latitude, longitude) {
        var _this = this;
        var _a, _b;
        var hasValue = this._latitude != null && this._longitude != null;
        if (map == null) {
            map = L.map(element, {
                zoom: hasValue ? zoomLevel : 0,
                center: [latitude !== null && latitude !== void 0 ? latitude : 0, longitude !== null && longitude !== void 0 ? longitude : 0]
            }).addLayer(osm);
            this._map = map;
        }
        var location = new L.LatLng((_a = this._latitude) !== null && _a !== void 0 ? _a : 0, (_b = this._longitude) !== null && _b !== void 0 ? _b : 0);
        this._currentMarker = new L.Marker(location, { draggable: !this._readonlyState });
        if (!this._readonlyState) {
            this._currentMarker.on('dragend', function (e) {
                var _a, _b;
                var latLng = (_a = _this._currentMarker) === null || _a === void 0 ? void 0 : _a.getLatLng();
                if (latLng != null) {
                    var latString = latLng.lat.toFixed(6);
                    var lngString = latLng.lng.toFixed(6);
                    latLng.lat = Number(latString);
                    latLng.lng = Number(lngString);
                    _this._latitude = latLng.lat;
                    _this._longitude = latLng.lng;
                    (_b = _this._map) === null || _b === void 0 ? void 0 : _b.panTo(latLng);
                    _this._$inputElement.val("".concat(latString, ", ").concat(lngString));
                }
            });
        }
        this._currentMarker.addTo(map);
    };
    LocationMap.isNumber = function (n) {
        return typeof n == 'number' && !isNaN(n - 0);
    };
    return LocationMap;
}());
